import {ExamBooked} from 'domain/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatCompleteAddress, formatDateString} from 'presentation/utils';
import {ParsedExamAppointment} from './types';

export const parseExamAppointments = (agendamentosExames: ExamBooked[]): ParsedExamAppointment[] =>
	agendamentosExames.map(item => ({
		bookingNumber: item.nuExame?.toString(),
		specialtyCode: item.cdTipoExame?.toString(),
		specialtyName: item.nmTipoExame,
		clinicName: item.nmPrestadorJuridico,
		unitCode: item.cdPrestadorJuridico?.toString(),
		providerName: item.nmPrestadorFisico,
		bookingType: item.tipoConsulta,
		formattedAddress: formatCompleteAddress(
			item.dsEnderecoPrestadorJuridico.replace(/-+/g, '-'),
		),
		date: formatDateString(item.dtExameMarcado, DateFormatEnum.DATE_FORMAT_1, 'P HH:mm'),
		dateOnly: formatDateString(
			item.dtExameMarcado,
			DateFormatEnum.DATE_FORMAT_1,
			DateFormatEnum.DATE_FORMAT_8,
		),
		hour: formatDateString(item.dtExameMarcado, DateFormatEnum.DATE_FORMAT_1, 'HH:mm'),
		formattedDateWithWeekday: formatDateString(
			item.dtExameMarcado,
			DateFormatEnum.DATE_FORMAT_1,
			'EEEE, dd/MM/yy',
		),
		telehealthUrl: null,
		protocolNumber: item.nuProtocolo,
		isConfirmed: item.flConfirmado === 'S',
		phoneNumbers: [],
	}));
